import type { ReactNode } from 'react'
import { Navigate } from 'react-router'
import { useAuth } from '@/lib/auth-context'

interface ProtectedRouteProps {
  children: ReactNode
  requireSuperAdmin?: boolean
}

export function ProtectedRoute({
  children,
  requireSuperAdmin = false,
}: ProtectedRouteProps): React.JSX.Element {
  const { user, isLoading, isSuperAdmin } = useAuth()

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-surface-0">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-admin-500 border-t-transparent" />
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  if (requireSuperAdmin && !isSuperAdmin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
